import React, { useState } from 'react';
import { Alert, Button, Card, CardBody, Spinner } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PhishingIcon from '../../../Layout/Components/PhishingIcon';
import PageTitle from '../../../Layout/Components/PageTitle';
import { getGroupList } from '../../../API/PhishingAPI';
import useChoices from '../useChoices';
import { GroupPicker } from '../Simulations/SimulationPickers';
import ChoiceDeleteModal from '../Simulations/ChoiceDeleteModal';
import UsersAndGroupsModal from './UsersAndGroupsModal';
import '../Simulations/Simulations.css';
import './UsersAndGroups.css';

export function UsersAndGroups({ t }) {
  const groups = useChoices(getGroupList);
  const [draft, setDraft] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  function saved(group) { groups.saved(group); setDraft(null); }
  function deleted(_kind, group) { groups.removed(group.id); setDeleteTarget(null); }
  function edit(group) { setDraft({ group }); }

  return <div className="simulation-wizard recipient-groups-page">
    <PageTitle heading={t('users_and_groups.title')} subheading={t('users_and_groups.workflow')} icon={<PhishingIcon name="users" />} />
    <Card className="simulation-wizard__shell"><CardBody>
      <div className="recipient-groups-page__heading">
        <div><h2>{t('users_and_groups.your_groups')}{groups.items && <span>{groups.items.length}</span>}</h2>
          <p>{t('users_and_groups.manage_help')}</p></div>
        <Button color="primary" disabled={!groups.items} onClick={() => setDraft({})}>+ {t('users_and_groups.actions.create')}</Button>
      </div>
      {groups.error && <Alert color="danger" role="alert">{t('users_and_groups.load_error')}{' '}
        <Button color="link" onClick={groups.load}>{t('template_gallery.retry')}</Button></Alert>}
      {!groups.items ? !groups.error && <div className="simulation-wizard__loading" role="status"><Spinner size="sm" /> {t('simulation_wizard.loading')}</div>
        : <GroupPicker manage items={groups.items} onSelect={edit} onEdit={edit} onCreate={() => setDraft({})}
          onDelete={item => setDeleteTarget({ kind: 'groups', item })} t={t} />}
    </CardBody></Card>
    {draft && <UsersAndGroupsModal open showOpenButton={false} group={draft.group} onClose={() => setDraft(null)} onSubmit={saved}
      contextHelp={t('simulation_wizard.group_edit_help')} />}
    {deleteTarget && <ChoiceDeleteModal target={deleteTarget} onClose={() => setDeleteTarget(null)} onDeleted={deleted} t={t} />}
  </div>;
}

export default withTranslation()(UsersAndGroups);
